import ObjectTableController from "./object_table_controller"

export default class ExchangeMarketDealsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "deal",
    subjectType: "deal",
    parentSubjectType: "market",
    enableEdit: false,
  }
}
